// Tag.styled.ts
import Link from "next/link";
import styled from "styled-components";

import { colourScheme } from "utils/styling/colours";

export const StyledLink = styled(Link)`
    display: inline-block;
    font-size: 0.875rem;
    padding: 0.125rem 0.625rem;
    border-radius: 9999px;
    border: 1px solid;
    background-color: ${colourScheme.greyDark};
    border-color: ${colourScheme.grey};
    text-decoration: none;

    &:hover {
        text-decoration: underline;
    }
`;
